export default __webpack_public_path__ + "static/media/guard3.3fe19457.png";